export default {
  title: 'Pré-approuver le cas',
  reviewCase:
    "Veuillez examiner le cas comme décrit dans l'email correspondant et cliquez sur le bouton ci-dessous pour approuver ou rejeter le cas.",
  description:
    "{employeeFirstName} {employeeLastName} demande à voyager vers {country} du {startDate} au {endDate}. {workationDays, plural, =1 {# jour de travail} other {# jours de travail}} à l'étranger et {vacationDays, plural, =1 {# jour de vacances} other {# jours de vacances}} sont prévus.",
  viewDetailsInApp:
    "Pour plus de détails sur cette demande, veuillez consulter le cas dans l'application Vamoz.",
  thankYou:
    'Merci pour votre contribution ! Vous pouvez fermer cette fenêtre maintenant.',
  approve: 'Approuver',
  reject: 'Rejeter',
  changeDecision: 'Changer de décision',
  modal: {
    approve: {
      title: 'Approuver le cas',
      subtitle: 'Êtes-vous sûr de vouloir approuver ce cas ?',
      confirm: 'Approuver'
    },
    revert: {
      title: 'Changer de décision',
      subtitle:
        "Cela vous permettra d'approuver ou de rejeter à nouveau le cas.",
      confirm: 'Changer'
    },
    reject: {
      title: 'Rejeter le cas',
      subtitle: 'Êtes-vous sûr de vouloir rejeter ce cas ?',
      confirm: 'Rejeter'
    }
  }
};
